module.exports = __webpack_public_path__ + "img/characters_desktop_right.c6e50982.png";